<template>
<div>
			<div style="padding:5px; font-size:1.8em; max-width:900px; width:100%; margin:10px auto; ">

				<Row>
					<Col :xs="6" :sm="4" :md="0" :lg="0" style="padding:5px" >
						<Button  v-if="ShowFilter"  @click="ShowFilterMobile=!ShowFilterMobile" style="display:block; width:100%; height:44px; margin-top:-4px; padding:0">
							FILTER
							<Icon type="ios-arrow-forward" />
						</Button>
					</Col>
					<Col :xs="ShowFilter  ? 18 : 24" :sm="ShowFilter ? 20 : 24" :md="24" :lg="24">
						<Input v-model="DelayedSearch" size="large" placeholder="search for style, fabric or color" on-blur="Blur" @on-change="textSearch" @on-focus="DelayedScrollToFocus" ref="searchEl" />
					</Col>
				</Row>


			</div>



		<Layout>
			<Drawer v-model="ShowFilterMobile" :closable="false" placement="left" :width="325">
				<div style="width:295px">
				<FilterContainer :Buckets="Buckets" :SelectedFilterOptions="AllBuckets()" :Items="FullData.Items" @changeBucket="ChangeBucket" />
				</div>
			</Drawer>

			<Layout>
			<div v-if="HasResults">
				<div  style="text-align:center; margin:15px 0 10px 0;">
					<Page  :total="TotalResultsCount" :current="activePage" :page-size="24" @on-change="pageChange" :style="Pager" />
				</div>

				<div style="height:30px"   v-if="ShowFilter">

					<FilterRemoval :SelectedBuckets="FullData.RemovableFilterOptions" @TextSearchRemoved="TextSearchRemoved" @BucketRemoved="RemoveBucket" @ColorFamilyRemoved="RemoveColorFamily" />
				</div>
				<Row>
					<Col :xs="0" :sm="0" :md="DynamicColumn('filter', 6)" :lg="DynamicColumn('filter', 4)" style="padding:5px"  v-if="ShowFilter">
						<FilterContainer :Buckets="Buckets" :SelectedFilterOptions="AllBuckets()" :Items="FullData.Items"  @changeBucket="ChangeBucket" />
					</Col>
					<Col :xs="24" :sm="24" :md="DynamicColumn('results', 18)" :lg="DynamicColumn('results', 20)">
						<div v-if="Items != null && Items.length > 0">
							<ProductListing :Items="Items" />
						</div>
					</Col>
				</Row>

				<div style="text-align:center; margin-bottom:30px; margin-top:20px">
					<Page :total="TotalResultsCount" :current="activePage" :page-size="24" @on-change="pageChange" :style="Pager" />
				</div>
		
		
				</div>
			</Layout>

		</Layout>
	</div>
</template>





<script>
import FilterContainer from './../ProductFilter/FilterContainer.vue';
import ProductListing from './../ProductListing.vue';
import FilterRemoval from './../ProductFilter/FilterRemoval.vue';
	
export default {
	name: 'StatelessCheetah',
	components: { FilterContainer, ProductListing, FilterRemoval },
	
	watch: {
        FilterOptions(nv) {
            this.DelayedSearch = this.FilterOptions.TextSearch;
            this.getData();
        }		
	},
	computed: {
		ShowPricing: {
			get: function() {
				return this.$root.showPricing
			},
			set: function(v) {
				this.$root.showPricing = v;
			}
		},
		HasResults() {
			return this.FullData.TotalResults > 0;
		},
		Buckets() {
			return this.FullData.Buckets;
		},
		Items() {
			return this.FullData.Items;
		},
		Pager() {
			return (this.FullData.TotalResults <= 20) ? 'visibility:hidden' : '';
		},
		activePage:  {
            set: function(v) { 
                this.$emit('FilterOptionsChanged', { ActivePage: v });
            },
			get: function() { return Number(this.FilterOptions.ActivePage); }
		},
		TotalResultsCount() {
			return this.FullData.TotalResults;
		},
	},
	props: {
        FilterOptions: Object,
		ShowFilter: { default: true, type: Boolean}
	},
	created() {
	},
	mounted() {
        this.DelayedSearch = this.FilterOptions.TextSearch;
		this.getData();
	},
	methods: {
		AllBuckets() {
			return this.FilterOptions.Bucket;			
		},
		DelayedScrollToFocus() {
			var _this = this;

			setTimeout(function() {
				_this.ScrollToFocus();
			}, 350)
		},
		Blur() {
			console.log('blur');
		},
		ScrollToFocus() {
			//return;
			var element = this.$refs.searchEl;
			//console.log(element);
			this.$scrollTo(element.$el);//, duration, options)
 		},
		FilterCountryCode() {
			return this.$countryCode() == 'gb' ? 'uk' : this.$countryCode();
		},
		DynamicColumn(wcol, icol)
		{
			if (wcol == 'filter') {
				if (this.ShowFilter)
				 return icol;
				else
				 return 0
			} else if (wcol == 'results')
			{
				if (this.ShowFilter)
				 return icol;
				else
				 return 24;
			}
			return 24;
        },
        RemoveColorFamily(cf) {
			this.$emit('FilterOptionsChanged', { ColorFamily:'', ActivePage: 1 });
        },
		RemoveBucket(bucket) {
			var term = bucket.Term;
			var arr = this.FilterOptions.Bucket.split('+');
			arr.splice($.inArray(bucket.Term, arr),1);
			this.$emit('FilterOptionsChanged', { Bucket: arr.join('+'), ActivePage: 1 });
        },
		TextSearchRemoved(term) {
            this.$emit('FilterOptionsChanged', { TextSearch: '', ActivePage: 1 });			
		},

		ChangeBucket(i) {
            var _this = this;
            var bucketArr = this.FilterOptions.Bucket.split('+');

            setTimeout(function() { 
                _this.ShowFilterMobile = false;
            }, 250)
            if (i.Type == 'bucket') {
                if (bucketArr.includes(i.Term)){
                    this.RemoveBucket(i);
                    return;
                }
                bucketArr.push(i.Term);
			    this.$emit('FilterOptionsChanged', { Bucket: bucketArr.join('+'), ActivePage: 1 });
            }
			else if (i.Type == 'color') {
			    this.$emit('FilterOptionsChanged', { ColorFamily: i.Term, ActivePage: 1 });                
			}



		},
		textSearch(t) {
            var _this = this;
            clearTimeout(this.DelayTimer);
            this.DelayTimer = setTimeout(function() {
			    _this.$emit('FilterOptionsChanged', { TextSearch: _this.DelayedSearch, ActivePage: 1 });
            }, 150); // Will do the ajax stuff after 1000 ms, or 1 s

		},
		reorderBuckets(r) {
			var result = {}; var terms = ['Collections', 'Fabric', 'Color Family', 'Dress Length', 'Style', 'Sleeve length'];
			
			$.each(terms, function(i, term) { 
				if (r.hasOwnProperty(term)) {
					result[term] = r[term];
					delete r[term];
				}
			})
			$.each(r, function(kO, vO) {
				result[kO] = vO;
			});

			return result;
		},
		getData(cb) {

				var _this = this;
				$.getJSON(this.$httpFFUrl() + '/api/filter?sort=styledesc&activepage=' + this.FilterOptions.ActivePage + '&textsearch=' + this.FilterOptions.TextSearch + '&colorfamily=' + this.FilterOptions.ColorFamily +  '&bucket=displaylooklive' + this.FilterCountryCode() + '+' + this.AllBuckets() + '&excludebucket=' + this.$exclusionBucket() + '&currencycode=' + this.$currencyCode() + '&countrycode=' + this.$countryCode()+ '&PrimaryBucket=' + this.FilterOptions.PrimaryBucket + '&imagesize=big&ResultsPerPage=24', function(r){
					r.Buckets = _this.reorderBuckets(r.Buckets)

                    _this.FullData.Buckets = r.Buckets;

                    
					if (cb != null) cb();
					

                    _this.FullData.Items = r.Items;
                    _this.FullData.RemovableFilterOptions = r.RemovableFilterOptions;
					_this.FullData.TotalResults = r.TotalResults;

            })
		},
		pageChange(p) {
			var doScroll = this.activePage != p;

			this.activePage = p;
			//this.getData();

			if (doScroll)
				this.ScrollToFocus();
		}

	},
	data() {
        return  { ShowFilterMobile: false, "FullData": {"Buckets":{}, "Items":[], TotalResults:0 }, "DelayedSearch":'', DelayTimer: null};
	}	
}
</script>
